import { useRaffleById } from '@/app/hooks/useRaffles'
import ButtonBack from '@/view/components/ButtonBack'
import { useParams } from 'react-router-dom'

import PrizeList from './components/PrizeList'
import RaffleCoupons from './components/RaffleCoupons'
import RaffleDetailSkeleton from './components/RaffleDetailSkeleton'
import RaffleInfo from './components/RaffleInfo'
import { RaffleWinners } from './components/RaffleWinners'

const RaffleDetail = () => {
  const { id } = useParams<{ id: string }>()
  const { data: raffle, isLoading } = useRaffleById(id!)

  if (isLoading) {
    return <RaffleDetailSkeleton />
  }

  if (!raffle) {
    return <div>Sorteio não encontrado.</div>
  }

  return (
    <div className="flex w-full flex-col gap-8">
      <ButtonBack label="Sorteios ativos" className="mb-0" />
      <RaffleInfo raffle={raffle} />
      <RaffleCoupons raffle={raffle} />
      <PrizeList prizes={raffle?.prizes} />
      <RaffleWinners winners={raffle?.winners} />
    </div>
  )
}

export default RaffleDetail
